module.exports = __webpack_public_path__ + "static/img/js_4.d874d54.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/coretesc/js_4.png
// module id = 6o8M
// module chunks = 1